import { BookDto, MeiliConsolidatedBookDto } from '@hermes/domains'
import useTranslateMessage from '@hooks/useTranslateMessage'

type MeiliBookVariant = MeiliConsolidatedBookDto['books'][number]
type BookDtoVariant = NonNullable<BookDto['versions']>[number]

const isMeiliBookVariant = (version: unknown): version is MeiliBookVariant =>
  (version as MeiliBookVariant).availability?.shipping !== undefined

const isBookDtoVariant = (version: unknown): version is BookDtoVariant =>
  (version as BookDtoVariant).availability !== undefined

const getPriceString = (price: number | null): string | null => {
  const { n } = useTranslateMessage()
  if (price === null) return null
  return n(price)
}

export const getVersionPriceLabel = (variant: MeiliBookVariant | BookDtoVariant): string | null => {
  if (isMeiliBookVariant(variant)) {
    const shippingPrice = getPriceString(variant.availability.shipping.priceAmount)
    const meetupPrice = getPriceString(variant.availability.meetup.priceAmount)
    const returnString = shippingPrice !== null ? shippingPrice : meetupPrice
    return returnString
  }

  if (isBookDtoVariant(variant)) {
    const shippingPrice = getPriceString(variant.availability.totalPrice) || null
    return shippingPrice
  }

  return null
}
